import { useNavigate } from 'react-router-dom';
import { MapPin, Clock, Calendar, Users } from 'lucide-react';
import { getCategoryColor, getCategoryLabel, formatDate } from '@/lib/api';

export default function GigCard({ opportunity }) {
  const navigate = useNavigate();
  const { opp_id, title, location, category, type, pay_amount, date, duration, spots, applications_count, creator_name, distance, zip_code, image_path, start_time, end_time } = opportunity;
  const catColor = getCategoryColor(category);
  const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

  return (
    <button
      onClick={() => navigate(`/opportunities/${opp_id}`)}
      className="w-full bg-white rounded-3xl border-2 border-gray-100 hover:border-[#2EC4B6] transition-all relative overflow-hidden text-left card-hover"
      data-testid={`gig-card-${opp_id}`}
    >
      {image_path && (
        <img
          src={`${API_URL}/files/${image_path}`}
          alt={title}
          className="w-full h-32 object-cover"
        />
      )}
      <div className="p-5">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2">
            <span
              className="inline-block px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wide text-white"
              style={{ backgroundColor: catColor }}
            >
              {getCategoryLabel(category)}
            </span>
            <span className={`px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wide ${
              type === 'paid' ? 'bg-[#FF9F1C] text-white' : 'bg-[#2EC4B6]/10 text-[#2EC4B6]'
            }`}>
              {type === 'paid' ? `$${pay_amount}` : 'Volunteer'}
            </span>
          </div>
          <h3 className="text-lg font-bold text-[#011627] truncate leading-tight">{title}</h3>
          <p className="text-sm text-[#5C6B7F] mt-1 font-semibold">{creator_name}</p>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-3 text-sm text-[#5C6B7F]">
        <span className="flex items-center gap-1">
          <MapPin size={14} strokeWidth={2.5} className="text-[#2EC4B6]" />
          <span className="truncate max-w-[120px]">{location?.name}</span>
        </span>
        <span className="flex items-center gap-1">
          <Calendar size={14} strokeWidth={2.5} className="text-[#FF9F1C]" />
          {formatDate(date)}
        </span>
        <span className="flex items-center gap-1">
          <Clock size={14} strokeWidth={2.5} className="text-[#6C63FF]" />
          {start_time && end_time ? `${start_time}-${end_time}` : `${duration}h`}
        </span>
        <span className="flex items-center gap-1">
          <Users size={14} strokeWidth={2.5} className="text-[#EC4899]" />
          {spots - (applications_count || 0)} spots
        </span>
        {distance !== undefined && distance !== null && (
          <span className="flex items-center gap-1 text-[#3A86FF] font-bold">
            <MapPin size={14} strokeWidth={2.5} />
            {distance} mi
          </span>
        )}
      </div>
      </div>
    </button>
  );
}
